import { Injectable } from '@angular/core';
import { faPlay, faSave } from '@optitax/design/lib/@fortawesome/pro-solid-svg-icons';
import { ButtonTypeEnum, FormFactory } from '@magieno/angular-advanced-forms';
import { AdvancedFormButton } from "@magieno/angular-advanced-forms";
import { ButtonStyleEnum } from '@magieno/angular-advanced-forms';

@Injectable()
export class ClientQuestionnaireBaseFactory {

  protected optionsType: { new(...args: any[]): object; };

  constructor(protected readonly formFactory: FormFactory) {
  }

  //todo we will need the icons back
  create() {
    return this.formFactory.create(new this.optionsType(), [
      new AdvancedFormButton('SAVE', ButtonStyleEnum.Light, 'Sauvegarder', ButtonTypeEnum.Button, { shouldSubmitIfValidationFail: true }),
      new AdvancedFormButton('SUBMIT', ButtonStyleEnum.Primary, 'Soumettre', ButtonTypeEnum.Submit, {}),
    ]);
  }
}